<script>
    import Cinema from "../components/Cinema.svelte";
    import { onMount } from "svelte";
    import { withResolvers } from "@otto-ec/assets-core-utils/promise";
    import emitHypotheticalEvent from "../tracking/trackHypothetical.js";
    import { getFeatureOrder, getIndex } from "../utils/externalTrackingHelper.js";

    let { data } = $props();
    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let index = $state(0);

    const {
        headline,
        recommendations,
        tracking,
        additionalClickTracking,
        metaData,
        featuresState,
        hasPersonalisedRecommendations = false,
        eventMergeId,
    } = data;

    let cinemaContainer;
    const [cinemaContainerMounted, mountSuccess] = withResolvers();

    onMount(async () => {
        emitHypotheticalEvent("RecoBasketNotPresent");
        if (!data.onlyEmitHypotheticalTracking) {
            attachParentVisibilityObserver(cinemaContainer);
            featureIndex = getFeatureOrder(cinemaContainer);
            index = getIndex(cinemaContainer);
            cinemaInjectionContainerWidth = parseInt(cinemaContainer?.offsetWidth) || 1000;
            mountSuccess();
        }
    });

    const attachParentVisibilityObserver = (targetElement) => {
        if (targetElement?.parentNode) {
            const parentObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    const isParentVisible = mutation.target.style.display !== "none";
                    if (isParentVisible) {
                        cinemaInjectionContainerWidth = targetElement.offsetWidth;
                    }
                });
            });
            parentObserver.observe(targetElement.parentNode, {
                attributes: true,
                attributeFilter: ["class"],
            });
        }
    };
</script>

{#if !data.onlyEmitHypotheticalTracking}
    <div bind:this={cinemaContainer}>
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            trackingEventMergeId={eventMergeId}
            loadedTrackingActionName="delete"
            site="reco_emptyBasket"
            personalisedUser={hasPersonalisedRecommendations}
            {cinemaContainerMounted}
        />
    </div>
{/if}
